import type { SceneDefinition } from "../../types/navigation";
import "./sceneTester.css";

type SceneTesterProps = {
  sceneList: SceneDefinition[];
  selectedScene: string;
  setSelectedScene: (sceneId: string) => void;
};

export function SceneTester({
  sceneList,
  selectedScene,
  setSelectedScene,
}: SceneTesterProps) {
  return (
    <div id="sceneTester">
      <select
        value={selectedScene}
        onChange={(e) => setSelectedScene(e.target.value)}
      >
        {sceneList.map(({ id }) => (
          <option key={id} value={id}>
            {id}
          </option>
        ))}
      </select>
    </div>
  );
}
